<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="flex flex-wrap field-value">
      <div
        v-if="isLoading"
        class="w-full mt-2 flex justify-center"
      >
        <BaseSpinner />
      </div>
      <ul
       v-else-if="programs.length"
       class="list-disc list-inside ml-4"
      >

        <li
          v-for="program in programs"
          :key="program.programGroupId"
        >
          <NuxtLink
            :to="getProgramUrl(program)"
            :title="getProgramLinkLabel(program)"
            class="mb-1 color-theme-light hover:color-theme-base underline transition-all duration-300 ease-in-out"
          >
            {{ getProgramLinkLabel(program) }}
          </NuxtLink>
        </li>
      </ul>
      <span v-else>{{emptyValuePlaceholder}}</span>
    </div>
  </div>
</template>

<script>
import ProgramsService from '@/services/programs'
import usePrograms from '@/composables/usePrograms'
import { generateProgramLabel } from '@/utils/dataLabels'

export default {
  props: {
    value: {
      type: [String, Array],
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const { getProgramUrl } = usePrograms(root)
    const getProgramLinkLabel = (program) =>
      generateProgramLabel(program, root.$store.state.settings.school)

    return { getProgramUrl, getProgramLinkLabel }
  },
  data: function() {
    return {
      programs: [],
      isLoading: false,
    }
  },
  computed: {
    emptyValuePlaceholder() {
      return this.question?.config?.emptyValuePlaceholder || '-'
    },
  },
  watch: {
    value: {
      handler: 'fetchPrograms',
      immediate: false
    }
  },
  async mounted() {
    await this.fetchPrograms()
  },
  methods: {
    async fetchPrograms() {
      const programIds = Array.isArray(this.value) ? this.value : [this.value]
      if (programIds.length === 0) {
        this.programs = []
        return
      }
      this.isLoading = true
      const api = new ProgramsService(this.$axios, this.$store)
      this.programs = await Promise.all(
        programIds.map((programId) => api.getProgram(programId))
      )
      this.isLoading = false
    }
  }
}
</script>
